import React, { useEffect, useState } from "react";
import Img from "../../common/Img";

const StudentInfo = ({ student }) => {

  const [_data, setData] = useState([]);

  useEffect(() => {
    let newData = [];
    setData(newData);
  }, []);

  return (
    <div className="print-table-area" style={{padding: '20px'}}>
      <div>
        <div className="print-profile" style={{height: "auto"}}>
          <Img src={student?.student_photo} alt=""/>
        </div>

        <div className="print-profile" style={{height: "auto"}}>
          <div className="print-identity-card" style={{height: "70px"}}>
            <div className="wrapper">
              <p>کد دانشجو</p>
              <h3>{student?.aria_id ?? ''}</h3>
            </div>
          </div>
        </div>
        <div className="print-identity">
          <div className="print-identity-card">
            <div className="wrapper">
              <p>نام</p>
              <h3>{student?.student_name ?? ''}</h3>
            </div>
          </div>
          <div className="print-identity-card">
            <div className="wrapper">
              <p>شماره</p>
              <h3>{student?.student_phone ?? ''}</h3>
            </div>
          </div>
          <div className="print-identity-card">
            <div className="wrapper">
              <p>دپارتمنت</p>
              <h3>{student?.department_name ?? ''}</h3>
            </div>
          </div>
          <div className="print-identity-card">
            <div className="wrapper">
              <p>سال ورود</p>
              <h3>{student?.entry_year ?? ''}</h3>
            </div>
          </div>
        </div>
        <div className="print-identity">
          <div className="print-identity-card">
            <div className="wrapper">
              <p>نام پدر</p>
              <h3>{student?.student_father_name ?? ''}</h3>
            </div>
          </div>
          <div className="print-identity-card">
            <div className="wrapper">
              <p>پوهنحی</p>
              <h3>{student?.faculty_name ?? ''}</h3>
            </div>
          </div>
          <div className="print-identity-card">
            <div className="wrapper">
              <p>صنف</p>
              <h3>{student?.class_desc ?? ''}</h3>
            </div>
          </div>
          <div className="print-identity-card">
            <div className="wrapper">
              <p>ایمیل</p>
              <h3>{student?.student_email ?? ''}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentInfo;
